// extracted by mini-css-extract-plugin
module.exports = {"exteriorStage":"ExteriorStage_exteriorStage__28E-e","exteriorStageImg":"ExteriorStage_exteriorStageImg__1n3Cs"};